/**
 * Release Notes Configuration
 *
 * Update this file with new version information when releasing updates.
 * The dialog will automatically show to users who haven't seen this version yet.
 */

export interface ReleaseNote {
  version: string;
  date: string;
  notes: {
    en: {
      title: string;
      items: string[];
    };
    'zh-HK': {
      title: string;
      items: string[];
    };
    'zh-CN': {
      title: string;
      items: string[];
    };
  };
}

export const CURRENT_RELEASE: ReleaseNote = {
  version: '1.0.12',
  date: '2026-06-22',
  notes: {
    en: {
      title: 'Release Highlights',
      items: [
        'Added feature to share assignments with other teachers',
        'Added ability for teachers to reorder questions when manually editing assignments',
        'Improved UI and experience of Free Practice',
        'Enhanced display of AI grading in the teacher\'s "Assignment Status"',
        'Improved stability of AI grading'
      ],
    },
    'zh-HK': {
      title: '版本更新',
      items: [
        '新增分享課業給其他老師功能',
        '新增教師端「人工編輯」作業時，可以修改題目的順序',
        '優化隨心練界面與體驗',
        '優化教師端「課業狀況」中AI批改的顯示',
        '優化AI批改的穩定性'
      ],
    },
    'zh-CN': {
      title: '版本更新',
      items: [
        '新增分享作业给其他老师功能',
        '新增教师端「人工编辑」作业时，可以修改题目的顺序',
        '优化随心练界面与体验',
        '优化教师端「作业状况」中AI批改的显示',
        '优化AI批改的稳定性'
      ],
    },
  },
};

const RELEASE_NOTES_STORAGE_KEY = 'eeelt_last_seen_version';

/**
 * Check if the current release notes should be shown to the user
 */
export function shouldShowReleaseNotes(): boolean {
  const lastSeenVersion = localStorage.getItem(RELEASE_NOTES_STORAGE_KEY);
  return lastSeenVersion !== CURRENT_RELEASE.version;
}

/**
 * Mark the current release notes as seen
 */
export function markReleaseNotesAsSeen(): void {
  localStorage.setItem(RELEASE_NOTES_STORAGE_KEY, CURRENT_RELEASE.version);
}
